import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React, { Component } from 'react';
import { Infraction } from './Infraction';
import './Infractions.js.css';

export class Infractions extends Component {
    render() {
        const { infractions } = this.props;

        return (
                <TableContainer>
                <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Description</TableCell>
                                <TableCell>Article</TableCell>
                                <TableCell>Montant</TableCell>
                                <TableCell>Date du constat</TableCell>
                            </TableRow>
                        </TableHead>
                    <TableBody>
                        {infractions.map((infraction, indexe) => (
                            <Infraction key={indexe + infraction.description} infraction={infraction}/>
                        ))}
                    </TableBody>
                </Table>
                </TableContainer>
        );
    }
}
